import { render, staticRenderFns } from "./AppFAB.vue?vue&type=template&id=e4fd0454&lang=pug&"
import script from "./AppFAB.vue?vue&type=script&lang=js&"
export * from "./AppFAB.vue?vue&type=script&lang=js&"
import style0 from "./AppFAB.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./AppFAB.vue?vue&type=style&index=1&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
installComponents(component, {VBtn,VIcon,VSpeedDial})
